import type { StateWithUsers, User } from './reducer'

export const getUsersInfo = (state: StateWithUsers): Record<UserID, User> =>
    state.users
